import {
	HOME_ANIMATE,
	SET_HOME_SHOW_VIDEO
} from './Types';

export const setHomeAnimate = bol => { return { type: HOME_ANIMATE, payload: bol } };
export const setHomeShowVideo = bol => { return { type: SET_HOME_SHOW_VIDEO, payload: bol } };


// WEBPACK FOOTER //
// ./src/actions/HomeActions.js